// eslint-disable-next-line import/no-cycle
import shareApi from '../api/shareApi';

import * as types from './types';
import * as rootTypes from '@/store/types';
import * as accountTypes from '@/modules/account/store/types';

const actions = {
  [types.FETCH_SHARE_WITH_EMAILS_LIST]: (context, payload) => shareApi
    .getShareWithEmailsList(payload)
    .then((response) => {
      context.commit(`account/${accountTypes.SET_SHAREES_COUNT}`, response.sharedWithEmails.length, { root: true });
      return response.sharedWithEmails;
    }),
  [types.UPDATE_SHARE_WITH_EMAILS_LIST]: (context, payload) => shareApi
    .postShareWithEmailsList(payload)
    .then((response) => {
      context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
        message: 'Shared successfully',
        type: 'success',
      }, { root: true });
      return response.sharedWithEmails;
    }),
  [types.RESEND_SHARE_WITH_EMAIL]: (context, payload) => shareApi
    .resendShareWithEmail(payload)
    .then((response) => response.sharedWithEmails),
  [types.REMOVE_EMAIL_FROM_SHARE_WITH]: (context, payload) => shareApi
    .deleteEmailFromShareWith(payload)
    .then((response) => {
      context.commit(rootTypes.SET_GLOBAL_MESSAGE, {
        message: 'User removed',
        type: 'success',
      }, { root: true });
      return response.sharedWithEmails;
    }),
};

export default actions;
